module.exports = __webpack_public_path__ + "img/Artboard_1.b15e5319.png";